/* eslint-disable */
import axios from "axios";
import { VERSAO, rotaDeProducao } from "./rotas";
import { CONSOLOGAR } from "@/components/Controle/debug";

let params = null
let cnpj = null
let idTerminal = null
let isMenuEstatico = null
let tipoCardapio = null
let isDelivery = null

/**
 * Monta a rota pra buscar itens
 * 
 * @param {*} temJsonSalvo 
 * @returns {string} rota de produtcao
 */
function rota(temJsonSalvo) {
    let urlProd = rotaDeProducao() +"/json-buscar?cnpj=" + cnpj + "&idTerminal=" + idTerminal + "&isMenuEstatico=" + isMenuEstatico + "&isDelivery=" + isDelivery + "&versao=" + VERSAO;
    // let urlProd = rotaDeProducao() +"/json-buscar-local?cnpj=" + cnpj + "&idTerminal=" + idTerminal + "&isMenuEstatico=" + isMenuEstatico + "&isDelivery=" + isDelivery + "&versao=" + VERSAO;
    if (!temJsonSalvo) {
        urlProd = rotaDeProducao() +"/itens?cnpj=" + cnpj + "&idTerminal=" + idTerminal + "&isMenuEstatico=" + isMenuEstatico + "&isDelivery=" + isDelivery + "&versao=" + VERSAO;   // para testes assim ==> http://localhost:8080/?00906885412592--25
    }
    console.log("url =>", urlProd);
    return urlProd;
}

/**
 * Seta as vars (cnpj, idTerminal, isMenuEstatico, tipoCardapio, isDelivery) para uso posterior
 * 
 * @param {*} tipoCardapioAqui (boolean ou string)
 */
async function setarVariaveisDeBusca(tipoCardapioAqui) {
    if (tipoCardapioAqui === true || tipoCardapioAqui === 'delivery') {
        tipoCardapio = 'delivery';
        isDelivery = true;
    } else if (tipoCardapioAqui === 'mesa' || tipoCardapioAqui === 'balcao' || tipoCardapioAqui === false) {
        tipoCardapio = tipoCardapioAqui === false ? 'mesa' : tipoCardapioAqui;
        isDelivery = false;
    } else {
        tipoCardapio = 'mesa';
        isDelivery = false;
    }

    console.log("tipoCardapio, isDelivery? ", tipoCardapio, isDelivery)
    let uri = window.location.href.split('?');    
    
    // caso seja o baitnazha, redirecionar para o cnpj deles
    if (window.location.href.includes("baitnazha")) {
        cnpj = 29274029000143
        idTerminal= 17
        isMenuEstatico = false;       
    } else {
        params = uri[1].split("--");
        cnpj = params[0];
        idTerminal = params[1];
        isMenuEstatico = params[2] == null ? false : true;
    }

    // vamos setar essas vars no session tbm so pra poder usar o darRefresh
    // cnpj, idTerminal, isMenuEstatico, isDelivery
}

/**
 * Buscamos todos os itens, checa pra ver se tem json (preferivel) ou busca normal caso nao tenha. Vai chamar a funcao @see setarVariaveisDeBusca() antes.
 * @param {boolean} isDelivery 
 * @param {boolean} isRefresh se for refresh, vamnos buscar a rota usando cnpj, idTerminal,  isMenuEstatico, isDelivery setados na session
 */
export async function buscarTodosItens(isDelivery, isRefresh) {
    if (!isRefresh) {setarVariaveisDeBusca(isDelivery)}
    try {
        const data = await axios.get(rota(true));
        if (data.status == 409) { // caso o cliente esteja com o allfood na versao errada
            throw (data.data)
        } else {
            let json = await corrigirJson(true, data)
            return json;
        }

    } catch (e) {
        console.log(e)
        if (e.response.status == 409) {
            alert("Versão do sistema desatualizada. Por favor, informe este erro ao garçom.")
            throw e.response.data.erro
        } else if (e.response.status == 404) {
            console.log("estabelecimento sem json salvo, buscando dados do DB")
            const data = await axios.get(rota(false));
            let json = await corrigirJson(false,data)
            return json;
        } else  {
            throw e;
        }
    }
    
}

/**
 * Faz correcoes finais no JSON depois de ter buscado os itens e antes de enviar pro front
 * @param {boolean} temJsonSalvo 
 * @param {import("axios").AxiosResponse} data                                                                                                                                                          
 * @returns {object}
 */
async function corrigirJson(temJsonSalvo, data) {
    let json = data.data;
    json['cnpj'] = cnpj;
    json['idTerminal'] = idTerminal;
    json['isMenuEstatico'] = isMenuEstatico;
    json['isDelivery'] = isDelivery;
    json['tipoCardapio'] = tipoCardapio;
    if (temJsonSalvo) {
        json = corrigirPromocoes(json)
        json = corrigirHoraVenda(json)
        json = await corrigirDadosDoTerminal(json, cnpj, idTerminal)
        json = corrigirCentroResultado(json)
    } else {
        json = corrigirCentroResultado(json)
    }
 
    return json;
}

/**
 * Pega a parte de promocoes que vem no json e aceta os itens verificando os dias e horarios das promocoes
 * @param {object} json 
 * @returns {object} json arrumado com as promocoes
 */
function corrigirPromocoes(jsonV) {
    let json = jsonV
    const promo = json['promo']
    const classes = json['classes']

    const listaPromo = []
    const listaPromoIds = []

    for (var i = 0; i < promo.length; i++) {
        const hojeEhDiaMes = checarDiaDoMes(promo[i])
        const hojeEhDiaSemana = checarDiaDaSemana(promo[i])
        const agoraEhHora = checarHora(promo[i])

        
        /** vamos checar od dias do mes e da semana e vwer se ta ativa */
        if (promo[i].ativa == "0") {console.log(`%c promo - FALHOU NO ATIVO  ${promo[i].CodigoProduto_FK}`, 'background: cyan; color: black')}
        if (agoraEhHora == false) {console.log(`%c promo - FALHOU NO horario  ${promo[i].CodigoProduto_FK}`, 'background: cyan; color: black')}
        if (hojeEhDiaSemana == false) {console.log(`%c promo - FALHOU NO dia da semana  ${promo[i].CodigoProduto_FK}`, 'background: cyan; color: black')}
        if (hojeEhDiaMes == false) {console.log(`%c promo - FALHOU NO dia do mes  ${promo[i].CodigoProduto_FK}`, 'background: cyan; color: black')}

        if (hojeEhDiaMes && hojeEhDiaSemana && agoraEhHora && promo[i].ativa == "1") {
            console.log(`%c esta promo esta rodando agora, codigo do prod:: ${promo[i].CodigoProduto_FK}`, 'background: violet; color: black')
            listaPromo.push({
                itemId: Number(promo[i].CodigoProduto_FK),
                valor: promo[i].Valor,
            })
            listaPromoIds.push(Number(promo[i].CodigoProduto_FK))
        }
    }

    for (var i = 0; i < classes.length; i++) {
        const itensVendaDaClasses = classes[i]
        for (var j = 0; j < itensVendaDaClasses.itensVenda.length; j++) {
            const item = itensVendaDaClasses.itensVenda[j]
            const idDoItem  = Number(item.id)
            if (listaPromoIds.includes(idDoItem)) {
                console.log(`%c promo passou em tudo :: ${item.nome} -- ${item.id}`, 'background: rgb(0,255,0); color: black')
                classes[i].itensVenda[j].promocao = listaPromo.filter((e) => e.itemId == idDoItem)[0].valor
            }

        }
    }

    json['classes'] = classes

    return json
}

/**
 * Pega a parte de horavenda que vem no json e acerta os itens. No json, o obj vem assim:
 *  [ {"Id": 17,"CodigoItensVenda_FK": 6031,"HoraInicio": "00:09:00","HoraFim": "00:11:00","Segunda": "1","Terca": "1","Quarta": "1","Quinta": "1","Sexta": "1","Sabado": "1","Domingo": "1","NumeroEmpresa_FK": 1,"Replicado": "0","naoVenderFeriados": "0"} ]
 * @param {object} json 
 * @returns {object} json arrumado com as horavenda
 */
function corrigirHoraVenda(jsonV) {
    let json = jsonV
    const horavenda = json['horavenda']
    const classes = json['classes']

    // const listaHoraVenda = []
    const listaHoraVendaIds = []


    for (var i = 0; i < horavenda.length; i++) {
        let item = horavenda[i]
        const hojeEhDiaSemana = checarDiaDaSemana(item)
        const agoraEhHora = checarHora(item)
        
        if (agoraEhHora == false) {console.log(`%c horavenda - FALHOU NO horario  ${item.CodigoItensVenda_FK}`, 'background: rgb(255,200,200); color: black')}
        if (hojeEhDiaSemana == false) {console.log(`%c horavenda - FALHOU NO dia da semana  ${item.CodigoItensVenda_FK}`, 'background: rgb(255,200,200); color: black')}

        if (hojeEhDiaSemana == false || agoraEhHora == false ) {
            listaHoraVendaIds.push(item.CodigoItensVenda_FK)
        }
    }


    for (var i = 0; i < classes.length; i++) {
        const cadaClasse = classes[i]

        const itensremover = cadaClasse.itensVenda.filter((e) => listaHoraVendaIds.includes(e.id))
        itensremover.forEach(itemss => {
            console.log(`%c horavenda - removendo o item :: ${itemss.nome} -- ${itemss.id}`, 'background: rgba(29, 99, 29, 1); color: white')
        })
        
        cadaClasse.itensVenda =  cadaClasse.itensVenda.filter((e) => !listaHoraVendaIds.includes(e.id))

        // aqui vamos remover as classes que, depois de todo esse calculo, acabaram ficando sem itens (pois todos os itens estao fora do horario de venda)
        if (cadaClasse.itensVenda.length == 0 || !cadaClasse.itensVenda) {
            delete classes[i]
        }
    }

    json['classes'] = classes
    return json
}


/**
 * Arruma os dados do tertminal como nomeTerminal e idGarcom e centroResultado, etc. Tem uma rota so pra isso pq o json salvo na aws so tem os itens. O terminal muda de mesa pra mesa (e o centro de resultado)
 * @param {Object} json 
 * @param {string} cnpj 
 * @param {string | number} idTerminal 
 * @returns 
 */
async function corrigirDadosDoTerminal(json, cnpj, idTerminal) {
    let urlProdTerminal = rotaDeProducao() +"/terminal?cnpj=" + cnpj + "&idTerminal=" + idTerminal;
    const dadosTerminalAxios = await axios.get(urlProdTerminal)
    const dadosTerminal = dadosTerminalAxios.data
    console.log("dadosTerminal")
    console.log(dadosTerminal)
    json.mesa = dadosTerminal.mesa;
    json.nomeTerminal = dadosTerminal.nomeTerminal;
    json.numeroEmpresaFK = dadosTerminal.numeroEmpresaFK;
    json.idgarcom = dadosTerminal.idgarcom;
    json.codigoCentroResultado = dadosTerminal.codigoCentroResultado;
    json.backgroundImage = dadosTerminal.backgroundImage;
    return json;
}

/**
 * Arruma as classes, tirando as que nao sao deste centro de resultado.
 * O json vem com todas as classes de todos os centros de resultados, e arrumaos aqui no front pra exibir apenas as classes deste centro de resultado.
 * O centro de resultado depende do @idTerminal - entao buscamos o centroResultado na rota @see corrigirDadosDoTerminal() e depois arrumamos aqui
 * @param {Object} json 
 * @returns {Object} json 
 */
async function corrigirCentroResultado(json) {
    json.classes = json.classes.filter(e => e.centroResultado == json.codigoCentroResultado)
    return json;
}


/**
 * Verifica se a data de hoje esta entre a data de inicio e data do fim da promocao
 * @param {object} promo 
 * @returns {boolean} true se tiver promocao hoje, false se nao tiver
 */
function checarDiaDoMes(promo) {
    const hoje = new Date()
    const dataInicioPromo = new Date(promo.DataInicio + "T00:00:00")
    const dataFinalPromo = new Date(promo.DataFinal + "T23:59:59")
    
    if (hoje >= dataInicioPromo && hoje < dataFinalPromo) {
        return true
    }
    return false
}




/**
 * Verifica se o horario de agora esta entre a hora de inicio e hora do fim da promocao ou horavenda
 * @param {object} promo 
 * @returns {boolean} true se tiver promocao hoje, false se nao tiver
 */
function checarHora(promo) {
    const [horaInicio, minutoInicio, segundoInicio] = promo.HoraInicio.split(":");
    let [horaFinal, minutoFinal, segundoFinal] = []
    if (promo.HoraFinal) {
        [horaFinal, minutoFinal, segundoFinal] = promo.HoraFinal.split(":");
    } else {
        [horaFinal, minutoFinal, segundoFinal] = promo.HoraFim.split(":");
    }
    const hoje = new Date()
    const hojeInicio = new Date()
    hojeInicio.setHours(horaInicio)
    hojeInicio.setMinutes(minutoInicio)

    const hojeFinal = new Date()
    hojeFinal.setHours(horaFinal)
    hojeFinal.setMinutes(minutoFinal)
    
    if (hoje >= hojeInicio && hoje < hojeFinal) {
        return true
    }
    return false
}

/**
 * Verifica se o dia da semana de hoje eh um dia da promocao ou horavenda
 * @param {object} promo 
 * @returns {boolean} true se tiver promocao hoje, false se nao tiver
*/
function checarDiaDaSemana(promo) {
    const hoje = new Date()
    const diaSemanaHoje = hoje.getUTCDay()

    if (diaSemanaHoje == 0) {
        if (promo.Domingo==  "1") return true
        return false
    }
    if (diaSemanaHoje == 1) {
        if (promo.Segunda==  "1") return true
        return false
    }
    if (diaSemanaHoje == 2) {
        if (promo.Terca==  "1") return true
        return false
    }
    if (diaSemanaHoje == 3) {
        if (promo.Quarta ==  "1") return true
        return false
    }
    if (diaSemanaHoje == 4) {
        if (promo.Quinta ==  "1") return true
        return false
    }
    if (diaSemanaHoje == 5) {
        if (promo.Sexta ==  "1") return true
        return false
    }
    if (diaSemanaHoje == 6) {
        if (promo.Sabado ==  "1") return true
        return false
    }
    return false;
}
